module.exports = __webpack_public_path__ + "static/media/bg1.ccca7740.jpg";